<template>
    <div>
        <h4 class="mt-1">
            {{ recoveryDetails.title }}
        </h4>
        <ol class="mb-1 text-mw">
            <li
                v-for="(step, index) in recoveryDetails.stepList"
                :key="'step-online-'+index"
            >
                {{ step }}
            </li>
        </ol>
        <template v-if="recoveryDetails.documentLabel && recoveryDetails.documentList">
            <p class="mb-0">
                <strong>{{ recoveryDetails.documentLabel }}</strong>
            </p>
            <template v-if="isDocumentListObject">
                <ul
                    id="online-details"
                    class="list mb-0"
                >
                    <li
                        v-for="(text, index) in recoveryDetails.documentList.texts"
                        :key="'doc-'+index"
                        class="text-mw"
                    >
                        {{ text }}
                    </li>
                </ul>
            </template>
            <p
                v-else
                id="online-details"
                class="mb-0"
                v-html="recoveryDetails.documentList"
            />
        </template>
        <template v-if="recoveryDetails.mentionList">
            <p
                v-for="(mention, index) in recoveryDetails.mentionList"
                :key="'mention-'+index"
                class="text-mw mb-0"
            >
                {{ mention }}
            </p>
        </template>
    </div>
</template>

<script>
export default {
    props: {
        recoveryDetails: {
            type: Object,
            required: true
        }
    },
    computed: {
        isDocumentListObject() {
            return this.recoveryDetails.documentList &&
                typeof this.recoveryDetails.documentList === 'object' &&
                Array.isArray(this.recoveryDetails.documentList.texts);
        }
    }
}
</script>

<style lang="scss">

p#online-details {
    ul.list {
        margin-bottom: 0;
    }
}

</style>
